import { routes } from '@/shared/routes';
import { formatCompanyNumber } from '@/shared/utils/format';
import { isValidCompanyNumber } from '@/shared/utils/validation';

import { close } from '@/front/actions/ui';
import { DELETE } from '@/front/fetch';
import { confirmModal } from '@/front/modal';

export const importOrganisation = (button: HTMLAnchorElement | HTMLButtonElement) => {
  const form = button.closest('form');

  const registrationNumberInput = form?.querySelector('[name="registrationNumber"]') as HTMLInputElement | null;
  const relationshipTypeInput = form?.querySelector('[name="relationshipType"]') as HTMLInputElement | null;

  const rawRegistrationNumber = registrationNumberInput?.value ?? '';
  const registrationNumber = formatCompanyNumber(rawRegistrationNumber);
  const relationshipType = relationshipTypeInput?.value;

  if (registrationNumberInput && registrationNumber !== rawRegistrationNumber) {
    registrationNumberInput.value = registrationNumber;
  }

  if (registrationNumber && isValidCompanyNumber(registrationNumber)) {
    const url = new URL(window.location.href);
    url.searchParams.set('registrationNumber', registrationNumber);
    if (relationshipType) url.searchParams.set('relationshipType', relationshipType);
    window.location.replace(url.toString());
  }
};

export const undoOrganisationImport = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const id = button.dataset.value;

  if (id) {
    if (
      await confirmModal(
        'Are you sure you want to undo your last import? This action can NOT be reversed.',
        'Undo',
        'danger',
      )
    ) {
      await DELETE(routes.organisations.import.delete({ id }));
      close();
    }
  }
};

export const undoIndividualImport = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const id = button.dataset.value;

  if (id) {
    if (
      await confirmModal(
        'Are you sure you want to undo your last import? This action can NOT be reversed.',
        'Undo',
        'danger',
      )
    ) {
      await DELETE(routes.individuals.import.delete({ id }));
      close();
    }
  }
};
